/**
 * @generated SignedSource<<8908e20cab258a93485fb0652a575922>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SeoRouteType = "ALIAS" | "PERMANENT_REDIRECT" | "REDIRECT";
export type UpdateSeoRouteInput = {
  h1?: string | null;
  metaDescription?: string | null;
  metaTitle?: string | null;
  promoLinkTitle?: string | null;
  promoLinkUrl?: string | null;
  promoText?: string | null;
  sourceUrl?: string | null;
  targetUrl?: string | null;
  type?: SeoRouteType | null;
};
export type SeoRouteEditSeoMutation$variables = {
  id: string;
  input: UpdateSeoRouteInput;
};
export type SeoRouteEditSeoMutation$data = {
  readonly updateSeoRoute: {
    readonly " $fragmentSpreads": FragmentRefs<"SeoRouteEditSeo_seoRoute" | "SeoRouteSidebar_seoRoute">;
  };
};
export type SeoRouteEditSeoMutation = {
  response: SeoRouteEditSeoMutation$data;
  variables: SeoRouteEditSeoMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SeoRouteEditSeoMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SeoRoute",
        "kind": "LinkedField",
        "name": "updateSeoRoute",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SeoRouteSidebar_seoRoute"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SeoRouteEditSeo_seoRoute"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SeoRouteEditSeoMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SeoRoute",
        "kind": "LinkedField",
        "name": "updateSeoRoute",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SeoRouteJsonParam",
            "kind": "LinkedField",
            "name": "jsonParams",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "metaTitle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "metaDescription",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "h1",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "promoText",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "promoLinkTitle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "promoLinkUrl",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "195de4ec42ac85881fa54aebf1b69668",
    "id": null,
    "metadata": {},
    "name": "SeoRouteEditSeoMutation",
    "operationKind": "mutation",
    "text": "mutation SeoRouteEditSeoMutation(\n  $id: ID!\n  $input: UpdateSeoRouteInput!\n) {\n  updateSeoRoute(id: $id, input: $input) {\n    ...SeoRouteSidebar_seoRoute\n    ...SeoRouteEditSeo_seoRoute\n    id\n  }\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n\nfragment SeoRouteEditSeo_seoRoute on SeoRoute {\n  id\n  metaTitle\n  metaDescription\n  h1\n  promoText\n  promoLinkTitle\n  promoLinkUrl\n}\n\nfragment SeoRouteJsonParams_seoRoute on SeoRoute {\n  jsonParams {\n    name\n    value\n  }\n}\n\nfragment SeoRouteSidebar_seoRoute on SeoRoute {\n  jsonParams {\n    name\n  }\n  ...EntitySidebar_entity\n  ...SeoRouteJsonParams_seoRoute\n}\n"
  }
};
})();

(node as any).hash = "eb9e5cbe86de983ca5d981a60a789de3";

export default node;
